"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _geoLocate = require("../../../../utils/geoLocate");

var _customProps = require("../../../../utils/customProps");

var _MobileStepper = _interopRequireDefault(require("../../../../components/PageGrid/templates/MobileStepper/MobileStepper"));

var GeoLocationMobileStepper = function GeoLocationMobileStepper(_ref) {
  var tabs = _ref.tabs,
      googleApiKey = _ref.googleApiKey;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  var _useState3 = (0, _react.useState)(googleApiKey),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      googleKey = _useState4[0],
      setGoogleApiKey = _useState4[1];

  (0, _react.useEffect)(function () {
    setGoogleApiKey(googleApiKey);
  }, [googleApiKey]);
  (0, _geoLocate.useSetGeoCode)(true, tabs, setActiveStep, googleKey);
  return /*#__PURE__*/_react.default.createElement(_MobileStepper.default, (0, _extends2.default)({}, tabs[0], {
    tabIndex: activeStep
  }));
};

var _default = GeoLocationMobileStepper;
exports.default = _default;
GeoLocationMobileStepper.propTypes = {
  /** key for googleApisKey to use geocode */
  googleApiKey: _propTypes.default.string,

  /** MobileStepper */
  tabs: function tabs(props, propName, componentName) {
    var components = ['MobileStepper'];
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, components, 1);
  }
};
GeoLocationMobileStepper.defaultProps = {
  tabs: [],
  googleApiKey: ''
};